import "./DownloadMobileApp.scss";
import * as React from "react";
import QRCode from "../../assets/images/qr-code.png";
import {ExitButton} from "../ExitButton/ExitButton";
import { useTranslation } from 'react-i18next';

interface DownloadMobileAppProps {
    isComponentVisible: boolean;
    onExitButtonClick: () => void;
}

export const DownloadMobileApp: React.FC<DownloadMobileAppProps> = (props: DownloadMobileAppProps) => {

    const { t } = useTranslation();

    return(
        <div className='download-mobile-app-component' >
            <div className="download-app-exit-button-container"><ExitButton onClick={() => props.onExitButtonClick()}/></div>
            <div className='download-mobile'>
                <h2>{t("Download our mobile app")}</h2>
                <div className="qr-code">
                    <a href={`https://qrco.de/bd20er`} title="QR Code" target="_blank" style={{display: "inline"}}>
                        <img src={QRCode} alt="QR code" />
                    </a>
                </div>
            </div>
        </div>
    )
}
